/**
 * 格式化工具函数
 */

/**
 * 格式化日期时间
 * @param dateString ISO 日期字符串
 * @returns 格式化后的日期时间字符串
 */
export const formatDateTime = (dateString: string | null): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * 格式化货币（分转元）
 * @param cents 金额（分）
 * @returns 格式化后的货币字符串
 */
export const formatCurrency = (cents: number): string => {
  const yuan = cents / 100;
  return `¥${yuan.toFixed(2)}`;
};
